
























































































import mixins from 'vue-typed-mixins';
import SurveyUtils, { Question } from '@/utils/SurveyUtils';
import questionsframework, { QuestionKey } from '@/components/survey/questions';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Question,
    },
  },

  computed: {
    questiontypes(): { value: { key: QuestionKey }; text: string }[] {
      // use components for the dropdown as many of them may not have any options
      const types = Object.keys(questionsframework.components).map((key) => ({
        value: this.questiontypesInternal?.find(
          (questiontype) => questiontype.key === key
        ) as Question['questiontype'],
        text: this.$tc(`model.question.type.${key}`),
      }));

      return types
        ?.filter((type) => !!type.value)
        .sort((a, b) => {
          return a.text.localeCompare(b.text);
        });
    },
  },

  data(): {
    questiontypesInternal?: Question['questiontype'][];
  } {
    return {
      questiontypesInternal: undefined,
    };
  },

  async mounted() {
    try {
      this.questiontypesInternal = await SurveyUtils.api.surveyQuestionType.list();

      this.$emit('input', {
        questiontype:
          this.value.questiontype &&
          this.questiontypes.find(
            (type) => type.value.key === this.value?.questiontype?.key
          )?.value,
        helptext: this.value.helptext
          ? Array.isArray(this.value.helptext)
            ? {}
            : this.value.helptext
          : {},
      });
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
});
